import React from 'react';
import { Outlet } from 'react-router-dom';
import AppHeader from './app-header';
import AppSidebar from './app-sidebar';
import { SidebarProvider } from './sidebar-context';

const AppShell: React.FC = () => {
  return (
    <SidebarProvider>
      <div className="flex h-screen overflow-hidden">
        <AppSidebar />
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          <AppHeader />
          <main className="flex-1 overflow-y-auto bg-gray-50 p-3 md:p-6">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
};

export default AppShell;
